<template>
    <div>
        <div class="fullscreen-page-title">
            {{ tokens.fullScreen.personalInfo.toUpperCase() }}
        </div>
        <div class="row">
            <div class="form-row fs">
                <div class="form-title">{{tokens.fullScreen.personalInfo.toUpperCase()}}</div>
            </div>
        </div>
        <div class="row fs">
            <div class="col">
                <div class="form-row fs">
                    <label class="fs">{{ tokens.fullScreenPersonal.firstName }}</label>
                    <input class="form-control fs"  v-model="personal.firstname" :disabled="!changePersonalName" @change="savePersonalName">
                </div>
                <div class="form-row fs">
                    <label class="fs">{{ tokens.fullScreenPersonal.email }}</label>
                    <input class="form-control fs" v-model="personal.email" disabled>
                </div>
                <div class="form-row fs">
                    <label class="fs">{{ tokens.fullScreenPersonal.country }}</label>
                    <input v-if="!canEditCountry" class="form-control fs" v-model="personal.country" disabled>
                    <select v-else class="form-control fs" v-model="personal.country" @change="saveCountry">
                       <option 
                            v-for="(countryName,countryCode) in countriesList()" 
                            :value="countryName" 
                            :key="countryCode" 
                        >{{ countryName }}</option>
                    </select>
                </div>
            </div>
            <div class="col">
                <div class="form-row fs">
                    <label class="fs">{{ tokens.fullScreenPersonal.lastName }}</label>
                    <input class="form-control fs" v-model="personal.lastname" :disabled="!changePersonalName" @change="savePersonalName">
                </div>
                <div class="form-row fs">
                    <label class="fs">{{ tokens.fullScreenPersonal.phone }}</label>
                    <input class="form-control fs" v-model="personal.phone" disabled>
                </div>
                <div class="form-row fs">
                    <label class="fs">{{ tokens.fullScreenPersonal.address }}</label>
                    <input class="form-control fs" v-model="personal.address" :disabled="canEditAddress" @change="saveAddress">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="form-row fs">
                <div class="form-title">
                    {{ tokens.fullScreenPersonal.profilePhoto.toUpperCase() }}
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col avatar">
                <div class="form-row fs">
                    <div class="circle" :class="{
                    pointer: !user.avatar,
                    over: fileOver
                }"
                         v-cloak
                         @drop.prevent="addFile"
                         @dragover.prevent
                         @dragenter="over(true)"
                         @dragleave="over(false)"
                         @dragover="over(true)"
                    >
                        <img :class="{hide: user.avatar}" :src="`../image/misc/avatar.png`" alt="">
                        <img v-auth-src="user.avatar ? '/avatar/'+user.avatar : ''" :class="{hide: !user.avatar}"/>
                    </div>
                    <input type="file" class="avatar" @change="documentSelected" />
                </div>
                <div class="form-row fs">
                    {{ tokens.fullScreenAvatar.dropFile }}
                </div>
            </div>
            <div class="col avatar">
                <div class="quote-block">
                    <div class="form-row fs">
                        <div class="form-title">
                            {{ tokens.fullScreenAvatar.notAllowed }}:
                        </div>
                    </div>
                    <div class="form-row fs">
                            - {{ tokens.fullScreenAvatar.notAllowedLine1 }}<br/>
                            - {{ tokens.fullScreenAvatar.notAllowedLine2 }}<br/>
                            - {{ tokens.fullScreenAvatar.notAllowedLine3 }}<br/>
                            - {{ tokens.fullScreenAvatar.notAllowedLine4 }}<br/>
                            - {{ tokens.fullScreenAvatar.notAllowedLine5 }}<br/>
                    </div>
                    <div class="form-row fs">
                        {{ tokens.fullScreenAvatar.requirements }}
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import {PERSONAL_UPDATE, AVATAR_UPLOAD} from "@/store/actions.type"
    import {BRAND, REST_ENDPOINT, STATIC_BASE, CHANGE_PERSONAL_NAME} from "@/common/config"
    import {countriesList} from "@/common/helpers"

    export default {
        name: "Personal",
        data() {
            return {
                personal: {
                    firstname: '',
                    lastname: '',
                    address: '',
                    country: '',
                    phone: '',
                    email: ''
                },
                apiBase: REST_ENDPOINT,
                fileOver: false,
                staticBase: STATIC_BASE,
                changePersonalName:CHANGE_PERSONAL_NAME,
                brand: BRAND
            }
        },
        methods: {
            savePersonal() {
                this.$store.dispatch(PERSONAL_UPDATE, {
                    firstname: this.personal.firstname,
                    lastname: this.personal.lastname,
                    address: this.personal.address,
                    country: this.personal.country,
                    phone: this.personal.phone
                })
            },
            savePersonalName() {
                this.$store.dispatch(PERSONAL_UPDATE, {
                    firstname: this.personal.firstname,
                    lastname: this.personal.lastname,
                })
            },
            saveAddress() {
                this.$store.dispatch(PERSONAL_UPDATE, {
                    address: this.personal.address
                })
            },
            saveCountry() {
                this.$store.dispatch(PERSONAL_UPDATE, {
                    country: this.personal.country
                })
            },
            addFile(e) {
                this.fileOver = false

                if (!e.dataTransfer.files) {
                    return
                }

                let data = new FormData()

                data.append('file', e.dataTransfer.files[0])

                this.$store.dispatch(AVATAR_UPLOAD, data)
            },
            documentSelected(e) {
                let data = new FormData()

                data.append('file', e.target.files[0])

                this.$store.dispatch(AVATAR_UPLOAD, data)

                e.target.value = ''
            },
            over(val) {
                this.fileOver = val
            },
            hideLastSymbols(value, hideSymbolsCounter){
                let start = value.substring(0, value.length - hideSymbolsCounter), end = ''
                for (let i = 0; i < hideSymbolsCounter; i++) {
                    end += "*"
                }
                return  start + end
            },
            countriesList
        },

        computed: {
            ...mapGetters(['user', 'tokens']),
            canEditAddress() {
                return !(['stage_sharksoft', 'byronplusglobal','zenithx24','mercuryfintech','investigbot'].includes(this.brand))
            },
            canEditCountry(){
                return (['stage_sharksoft','investigbot'].includes(this.brand))
            }
        },
        watch: {
            user: {
                deep: true,
                handler(val) {
                    for (let n in val) {
                        this.personal[n] = val[n]
                        if (BRAND === 'swissiam' && n === 'phone' && val[n]){
                            this.personal[n] = this.hideLastSymbols(val[n], 3)
                        }
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .row {
        display: grid;
        grid-template-columns: repeat(2,1fr);
        margin-bottom: .5vw;
    }

    .col {
        flex: 1 1 40%
    }

    .col:last-child {
        margin-left: 30px;
    }

    input, select {
        width: 100%;
        font-size: 1.2em;
    }

    .col.avatar {
        flex: 1 1 50%;
        height: 100%;
        justify-content: center;
        background-color: var(--background-dark-mid);
        border: .1vw solid var(--fs-border);
        border-radius: .3vw;
    }

    .col.avatar:first-child {
        align-items: center;
    }

    .form-row {
        position: relative;
        overflow: hidden;
    }

    .circle {
        height: 200px;
        width: 200px;
        border-radius: 50%;
        background-color: var(--background);
        transition: background-color ease-in-out 0.3s;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
    }

    .circle img {
        height: 200px;
        width: 200px;
    }

    .circle i {
        font-size: 5em;
    }

    .circle.over {
        border: 1px solid var(--white);
    }

    .circle.over i {
        color: var(--white)
    }

    input.avatar {
        position: absolute;
        width: 150%;
        height: 150%;
        left: -50%;
        top: -50%;
    }

    .pad {
        margin-bottom: 50px;
    }

    @media (min-width: 1000px) {

        .form-row.fs{
            font-size: 1vw;
        }

        .col {
            flex: 1 1 40%
        }

        .col:last-child {
            margin-left: 1.5vw;
        }

        input, select {
            width: 100%;
            font-size: 1.2vw;
        }

        .col.avatar {
            flex: 1 1 50%
        }


        .circle {
            height: 10vw;
            width: 10vw;
        }

        .circle img {
            height: 10vw;
            width: 10vw;
        }

        .circle i {
            font-size: 2.6vw;
        }

        .pad {
            margin-bottom: 2.6vw;
        }
    }

    @media (max-width: 1000px) {
        .row{
            grid-template-columns: 1fr;
            grid-template-rows: auto;
        }

        .row:last-child{
            gap: 25px;
        }

        .col:last-child{
            margin-left: 0;
        }

        .row.fs{
            grid-template-columns: 1fr;
        }

        .col.avatar{
            padding-top: 20px;
        }
        .col.avatar:last-child{
            padding-top: 0;
        }

    }

    @media (max-width: 767px) {
        .col {
            margin-left: 0 !important;
            flex: 1 1 100%
        }
    }
</style>
